import { useI18nContext } from "@hopper-b2b/i18n";
import {
  ActionLink,
  IconComponent,
  IconName,
  MobilePopoverCard,
} from "@hopper-b2b/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

interface ConfirmRyanairPopoverProps {
  isOpen: boolean;
  onCancel: () => void;
  onContinue: () => void;
}

export const ConfirmRyanairPopover = ({
  isOpen,
  onCancel,
  onContinue,
}: ConfirmRyanairPopoverProps) => {
  const { t } = useI18nContext();
  return (
    <MobilePopoverCard
      className={styles.ConfirmRyanairPopover}
      paperClassName={styles.ConfirmRyanairPopoverPaper}
      open={isOpen}
      onClose={onCancel}
      topRightButton={
        <ActionLink
          className="close-button"
          content={
            <IconComponent
              ariaLabel="Close button icon"
              className={clsx("close-button-icon")}
              name={IconName.Close}
            />
          }
          label="Close"
          onClick={onCancel}
        />
      }
    >
      <div className={styles.ConfirmRyanairPopoverContent}>
        <h2 className="title">{t("ryanair.title")}</h2>
        <div className="steps">
          <div className="row">
            <p className="number-label">1</p>
            <p className="text">{t("ryanair.stepsToComplete.one")}</p>
          </div>
          <div className="row">
            <p className="number-label">2</p>
            <p className="text">{t("ryanair.stepsToComplete.two")}</p>
          </div>
          <div className="row">
            <p className="number-label">3</p>
            <p className="text">{t("ryanair.stepsToComplete.three")}</p>
          </div>
          <div className="row">
            <p className="number-label">4</p>
            <p className="text">{t("ryanair.stepsToComplete.four")}</p>
          </div>
          <div className="vertical-bar"></div>
        </div>

        <button onClick={onContinue} className="continue-button">
          {t("ryanair.continueAction")}
        </button>
        <button onClick={onCancel} className="cancel-button">
          {t("ryanair.close")}
        </button>
      </div>
    </MobilePopoverCard>
  );
};
